// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "@rescript/std/lib/es6/belt_List.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Json_encode from "@glennsl/bs-json/src/Json_encode.bs.js";

function register(l) {
  var orderNumber = Belt_Option.mapWithDefault(l.orderNumber, /* [] */0, (function (number) {
          return {
                  hd: [
                    "claim_order_number",
                    number
                  ],
                  tl: /* [] */0
                };
        }));
  return Json_encode.object_(Belt_List.concat({
                  hd: [
                    "first_name",
                    l.firstName
                  ],
                  tl: {
                    hd: [
                      "last_name",
                      l.lastName
                    ],
                    tl: {
                      hd: [
                        "email",
                        l.email
                      ],
                      tl: {
                        hd: [
                          "phone",
                          l.phoneNumber
                        ],
                        tl: {
                          hd: [
                            "password",
                            l.password
                          ],
                          tl: {
                            hd: [
                              "security_code",
                              l.securityCode
                            ],
                            tl: {
                              hd: [
                                "marketing_optin",
                                l.marketingOptIn
                              ],
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }, orderNumber));
}

var Encode = {
  register: register
};

export {
  Encode ,
}
/* No side effect */
